import React from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Title from './Title';
import { Link } from "react-router-dom";

function preventDefault(event) {
	event.preventDefault();
}

const useStyles = makeStyles((theme) => ({
	seeMore: {
		marginTop: theme.spacing(3),
	},
}));

const clickFamasItem = (p_item) =>{

}

export default function Orders(props) {
	const {data} = props;

	const classes = useStyles(); 
	return (
		<React.Fragment>
			
			
			
		</React.Fragment>
	);
}
